import { ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { useRouter } from "vue-router"
import { useCache } from './useCache'
import { Notify, Dialog  } from 'vant'
import { getUrlKey } from '@/utils/util'
import { useRequest } from './useRequest'
import { customerService } from "@/utils/getCustomerService"

function fieldMapKey(source, target, fieldKeys) {
    Object.keys(fieldKeys).forEach((key) => {
        if (Array.isArray(fieldKeys[key])) {
            fieldKeys[key].map((keyName, keyIndex) => {
                if (source[keyName]) {
                    target[key] += source[keyName] + (keyIndex === fieldKeys[key].length - 1 ? '' : '/')
                }
            })
        } else {
            if (key === 'tel' && source[key] === '') {
                // 门店电话为空时, 将老板电话作为门店电话显示
                if (source['bossPhone']) {
                    target[fieldKeys[key]] = source['bossPhone']
                }
            } else {
                if (Array.isArray(target[fieldKeys[key]])) {
                    if (Array.isArray(source[key])) {
                        if (source[key].length > 0) {
                            source[key].map((imgUrl) => {
                              target[fieldKeys[key]].push(imgUrl)
                            })
                        }
                    } else {
                      if (source[key]) {
                        target[fieldKeys[key]].push({url: source[key]})
                      }
                    }
                } else {
                    target[fieldKeys[key]] = source[key] ? source[key] : ''

                }
            }
        }
    })
}

export function makerFieldForm() {
    let phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
    let telReg = /^(?:(?:\d{3}-?)?\d{8}|^(?:\d{4}-?)?\d{7,8})(?:-\d+)?$/

    const { proxy } = getCurrentInstance()
    const { getCache, removeCache, setCache } = useCache()
    const router = useRouter()
    const { useApi } = useRequest()
    const showProxySale = ref(false)
    const resdisabled = ref(false)
    const isRegrster = ref(1)
    const showPicker = ref(false)
    const storeData = reactive({})
    const showMap = ref(false)
    const id = ref(0)
    const applyRemark = ref('')
    let submitFormData = {
      userName: '',
      age: '',
      phone: '',
      smsCode: '',
      idCardFront: [],
      idCardBack: [],
      userImage: [],
      graduateSchool: '',
      professional: '',
      userAddress: '',
      position: [],
      workExperience: '',
      workPicture: [],
      workAbility: '',
      workCertificate: [],
      caseScore: '',
      casePhoto: [],
      joinRole: [],
      workZone: [],
      referenceCheck: [1],
      caseVideo: [],
      userId: 0,
    }

    const fieldKeyMap = {
      userName: 'userName',
      age: 'age',
      phone: 'phone',
      smsCode: 'smsCode',
      idCardFront: 'idCardFront',
      idCardBack: 'idCardBack',
      userImage: 'userImage',
      position: 'position',
      userAddress: 'userAddress',
      graduateSchool: 'graduateSchool',
      professional: 'professional',
      workExperience: 'workExperience',
      workPicture: 'workPicture',
      workAbility: 'workAbility',
      workCertificate: 'workCertificate',
      caseScore: 'caseScore',
      casePhoto: 'casePhoto',
      joinRole: 'joinRole',
      workZone: 'workZone',
      referenceCheck: 'referenceCheck',
      caseVideo: 'caseVideo',
      userId: 'userId',
    }

    const fieldForm = reactive({
      // 创客字段
      userName: '',
      age: '',
      phone: '',
      smsCode: '',
      idCardFront: [],
      idCardBack: [],
      userImage: [],
      userAddress: '',
      joinRole: [],
      graduateSchool: '',
      professional: '',
      workExperience: '',
      workPicture: [],
      workAbility: '',
      workCertificate: [],
      caseScore: '',
      casePhoto: [],
      workZone: [],
      referenceCheck: [1],
      caseVideo: [],
      id: 0,
      position: [],
    })

    onMounted(() => {
        const id = getUrlKey('id')
        let formData = getCache('submitFormData')

        // 先处理缓存数据
        if (id && formData && id == formData.id) {
            submitFormData = formData
            fieldMapKey(formData, fieldForm, fieldKeyMap)
        } else {
            removeCache('submitFormData')
            setFieldValue('id', id)
        }

        // 确保referenceCheck字段始终存在且为非空数组
        if (!submitFormData.referenceCheck || (Array.isArray(submitFormData.referenceCheck) && submitFormData.referenceCheck.length === 0)) {
            submitFormData.referenceCheck = [1]
        }

        // 更新fieldForm和缓存
        setFieldValue('referenceCheck', submitFormData.referenceCheck)
        setFieldValue('userId', getUrlKey('id'))

        getMakerInfo()
    })



    const verifyStore = async(phone) => {
        if (!phone) return
        if (phone && !phoneReg.test(phone)) {
          return
        }
        let params = {}
        if (phone) params['phone'] = phone
        try {
            let { result } = await useApi({
                url: '/store_settled/add_verify',
                method: 'post',
            }, params)

            if (result.success) {
                let data = result.data
                if (data && data.id) {
                   Object.assign(storeData, data)
                }
            } else {
                console.log('verifyStore', result)
            }
        } catch (error) {
            console.log('verifyStore', error)
        }
    }

    const setFieldValue = (fieldKey, fieldValue) => {
        if (fieldKey === 'phone' && fieldValue && !phoneReg.test(fieldValue)) {
          return proxy.$toast('手机号码格式有误')
        }
        if (fieldKey === 'tel' && fieldValue && !phoneReg.test(fieldValue) && !telReg.test(fieldValue)) {
          return proxy.$toast('门店电话格式有误')
        }

        if (fieldKey !== '') {
            let formData = getCache('submitFormData')
            if (formData) {
                if (Array.isArray(fieldKey) && Array.isArray(fieldValue)) {
                    fieldKey.map((key, index) => {
                        formData[key] = fieldValue[index]
                    })
                } else {
                    // 对于数组类型，比较内容而不是引用
                    if (Array.isArray(formData[fieldKey]) && Array.isArray(fieldValue)) {
                        if (JSON.stringify(formData[fieldKey]) === JSON.stringify(fieldValue)) return
                    } else if (formData[fieldKey] === fieldValue) {
                        return
                    }
                    formData[fieldKey] = fieldValue
                }
                setCache('submitFormData', formData)
            } else {
                if (Array.isArray(fieldKey) && Array.isArray(fieldValue)) {
                    fieldKey.map((key, index) => {
                        submitFormData[key] = fieldValue[index]
                    })
                } else {
                    submitFormData[fieldKey] = fieldValue
                }
                setCache('submitFormData', submitFormData)
            }
            if (fieldValue !== '' && fieldKey!== 'id') {
                Notify({
                    color: '#0F50C5',
                    background: '#f4f7ff',
                    duration: 1000,
                    message: '已自动保存信息下次进入可继续填写，点击确认后提交申请资料'
                })
            }
        }
    }

    const openService = () => {
      const isWxMiniProgram = window.__wxjs_environment === 'miniprogram' || navigator.userAgent.indexOf('miniProgram') > -1;
      if(isWxMiniProgram) {
        proxy.$http.post('/base/kefu').then(({ data: res }) => {
          if (res?.success) {
            const data = res.data
            data.id = getUrlKey('id')
            data.from = getUrlKey('from')
            customerService(data)
          } else {
            proxy.$toast(res.errorMessage)
          }
        }).catch(err => console.log('err', err))
      } else {
        Dialog({
            title: '提示',
            message: '是否需要联系客服？',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            confirmButtonColor: '#3363DE',
            cancelButtonColor: '#C7C7C7',
        }).then( async () => {
          try {
            let { result } = await useApi({
                url: '/base/kefu',
                method: 'post'
            }, { id: 0, AdCode: '' })
            if (result.success) {
                const data = result.data
                data.id = getUrlKey('id')
                data.from = getUrlKey('from')
                customerService(data)
            } else {
              proxy.$toast(result.errorMessage)
            }
            } catch (error) {
               console.log('getWechatUrlLink', error)
            }
        }).catch(() => {
            proxy.$toast('已取消')
        });
      }
    }

    const submitUserData = async() => {
      if(resdisabled.value) return
      let formData = getCache('submitFormData') || submitFormData
      console.log(formData)
      const verifyData = {}
      const verifyRules = [
        {
          verifyKey: 'userName',
          title: '请填写您的姓名'
        },
        {
          verifyKey: 'age',
          title: '请填写您的年龄'
        },
        {
          verifyKey: 'phone',
          title: '请填写您的手机号'
        },
        {
          verifyKey: 'smsCode',
          title: '请填写验证码'
        },

        {
          verifyKey: 'idCardFront',
          title: '请上传您的身份证正面件照'
        },
        {
          verifyKey: 'idCardBack',
          title: '请上传您的身份证反面件照'
        },
        {
          verifyKey: 'userImage',
          title: '请上传您的个人形象照'
        },
        {
          verifyKey: 'userAddress',
          title: '请选择您的常住地址'
        },

        {
          verifyKey: 'joinRole',
          title: '请选择您的入驻角色'
        },
        {
          verifyKey: 'workZone',
          title: '请选择您的可接受工作位置范围'
        },

        {
          verifyKey: 'workExperience',
          title: '请填写您从业经验（概述）'
        },
        {
          verifyKey: 'workPicture',
          title: '请上传您的从业经历照片'
        },
        {
          verifyKey: 'workAbility',
          title: '请填写您的专业能力（概述）'
        },
        {
          verifyKey: 'referenceCheck',
          title: '请先勾选同意声明及相关协议'
        },
      ]

      for (let rule of verifyRules) {
          if (Array.isArray(formData[rule['verifyKey']]) && formData[rule['verifyKey']].length === 0) {
            verifyData.title = rule.title
            break
          } else if (!formData[rule['verifyKey']]) {
            verifyData.title = rule.title
            break
          }
      }

      if (verifyData.title) {
        return proxy.$toast(verifyData.title)
      }
      if (formData.smsCode.length !== 6) {
        return proxy.$toast('手机验证码有误')
      }
      if (fieldForm.phone) {
        if (!phoneReg.test(fieldForm.phone) && !telReg.test(fieldForm.phone)) {
            proxy.$toast({
              message: '手机号格式有误',
              duration: 1000,
            })
            return
        }
      }
      // formData.lat= formData.position[1] + '' || ''
      // formData.lng= formData.position[0] + '' || ''
      const params = {
        id: formData.id,
        code: formData.smsCode,
        user_id: Number(getUrlKey('id')),
        user_from: Number(getUrlKey('from')),
        username: formData.userName,
        age: Number(formData.age),
        phone: formData.phone,
        idcard_front: Array.isArray(formData.idCardFront) && formData.idCardFront.length ? formData.idCardFront[0].url : formData.idCardFront,
        idcard_back: Array.isArray(formData.idCardBack) && formData.idCardBack.length ? formData.idCardBack[0].url : formData.idCardBack,
        user_image: formData.userImage.length ? formData.userImage.map(item => item.url).join(',') : '',
        user_address: formData.userAddress,
        join_role: formData.joinRole.join(','),
        graduate_school: formData.graduateSchool,
        study_field: formData.professional,
        work_zone: formData.workZone.join(','),
        work_experience: formData.workExperience,
        work_picture: formData.workPicture && formData.workPicture.length ? formData.workPicture.map(item => item.url).join(',') : '',
        work_ability: formData.workAbility,
        work_certificate: formData.workCertificate && formData.workCertificate.length ? formData.workCertificate.map(item => item.url).join(',') : '',
        work_case: formData.caseScore ? formData.caseScore : '',
        work_case_picture: formData.casePhoto && formData.casePhoto.length ? formData.casePhoto.map(item => item.url).join(',') : '',
        reference_check: formData.referenceCheck[0],
        work_case_video: formData.caseVideo && formData.caseVideo.length ? formData.caseVideo.map(item => item.url).join(',') : '',
        id: id.value
      }
      resdisabled.value = true
      let time = proxy.$toast.loading('加载中...')
      try {
        let { result } = await useApi({
          url: id.value ? '/h5/fans_maker/update' : '/h5/fans_maker/create',
          method: 'post',
        }, params)
        if (result.success) {
          time.close()
          removeCache('submitFormData')  // 提交后移除本地缓存的表单数据
          isRegrster.value = 2
        } else {
          proxy.$toast({
            message: result.errorMessage,
            duration: 1500,
          })
        }
      } catch (error) {
        console.log('submitUserData', error)
      } finally {
        resdisabled.value = false
      }
    }

    const getMakerInfo = () => {
      const params = {
        user_from: Number(getUrlKey('from')),
        user_id: Number(getUrlKey('id'))
      }
      proxy.$http.post('/h5/fans_maker/get_by_user_id', params).then(({ data: res }) => {
        if(!res.success) {
          return
        }
        const info = res?.data
        id.value = info.id || ''
        applyRemark.value = info.apply_remark || ''
        const obj = {
          userName: info.username,
          age: info.age,
          phone: info.phone,
          smsCode: '',
          idCardFront: [{ url: info.idcard_front }],
          idCardBack: [{ url: info.idcard_back }],
          userImage: info.user_image.length ? info.user_image.map(item => ({ url: item })) : [],
          userAddress: info.user_address,
          joinRole: info.join_role.split(','),
          graduateSchool: info.graduate_school,
          professional: info.study_field,
          workExperience: info.work_experience,
          workPicture: info.work_picture.length ? info.work_picture.map(item => ({ url: item })) : [],
          workAbility: info.work_ability,
          workCertificate: info.work_certificate.length ? info.work_certificate.map(item => ({ url: item })) : [],
          caseScore: info.work_case,
          casePhoto: info.work_case_picture.length ? info.work_case_picture.map(item => ({ url: item })) : [],
          workZone: info.work_zone.split(','),
          referenceCheck: [1],
          caseVideo: [],
          position: []
        }
        // fieldForm
        Object.keys(obj).forEach(key => {
          fieldForm[key] = obj[key]
          setFieldValue(key, obj[key])
        })

      }).catch(err => console.log('err', err))
    }

    return {
        fieldForm,
        setFieldValue,
        submitUserData,
        verifyStore,
        openService,
        resdisabled,
        isRegrster,
        showPicker,
        showProxySale,
        storeData,
        showMap,
        id,
        applyRemark
    }
}
